import React, { useMemo, useState } from "react";
import map from "lodash/map";
import get from "lodash/get";

import set from "@rill/set";
import cx from "classnames";
import SettingsNav from "../../parts/settings-nav";
import SvgIcon from "../../parts/SvgIcon";

const {
  NOTIFICATIONS: { ICONS },
} = require("../../constants");

function View(props, { locals }) {
  const { listNotifications, momentTZ } = locals;
  const [selectedList, setSelectedList] = useState([]);
  const handleSelectNotification = (e, id) => {
    e.preventDefault();
    setSelectedList((list) => {
      if (list.indexOf(id) > -1) {
        return list.filter((item) => item !== id);
      } else {
        return [...list, id];
      }
    });
  };
  const handleDeselectAll = (e) => {
    if (e) e.preventDefault();
    setSelectedList([]);
  };

  const handleSelectAll = (e) => {
    e.preventDefault();
    const selected = listNotifications
      .filter(({ read }) => !read)
      .map(({ _id }) => _id);
    setSelectedList(selected);
  };
  const unread = useMemo(() => {
    return listNotifications.filter((notification) => !notification.read)
      .length;
  }, [listNotifications]);
  const allSelected = unread === selectedList.length;
  const handleMarkRead = (e) => {
    e.preventDefault();
    submit(`/actions/notification/read-all`, {
      method: "POST",
      // body: {
      //   notifications: selectedList.length
      //     ? selectedList
      //     : notificationList.filter(({ read }) => !read).map(({ _id }) => _id),
      // },
    });
    handleDeselectAll();
  };
  return (
    <main className="settings">
      <SettingsNav />
      {/* <a className="settings" href="/dashboard/settings/notifications">
        Notification Settings
      </a> */}

      <section className="notifications">
        <header>
          <h3>Notifications</h3>
          <hgroup>
            <div></div>
            {unread > 0 && (
              <button data-button-type="primary" onClick={handleMarkRead}>
                Mark {selectedList.length ? `${selectedList.length}` : "all"} as
                read
              </button>
            )}
          </hgroup>
        </header>
        <section role="table-wrapper" data-borders-inside>
          <table role="report-table">
            <thead>
              <tr>
                <th>
                  {unread > 0 && (
                    <SvgIcon
                      src={
                        allSelected
                          ? "/img/new-icons/checked-square.svg"
                          : "/img/new-icons/unchecked-square.svg"
                      }
                      onClick={
                        allSelected ? handleDeselectAll : handleSelectAll
                      }
                    />
                  )}
                </th>
                <th>Date</th>
                <th>Description</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {map(listNotifications, (notification) => {
                const isSelected = selectedList.includes(notification._id);
                const notificationText =
                  notification.type === "Push"
                    ? "Your coach has sent you a new training block. Click the button to add to your calendar."
                    : notification.text;
                return (
                  <tr key={notification._id}>
                    {!notification.read && (
                      <a
                        className="mark-read"
                        href={`/actions/notification/read/${notification._id}`}
                      >
                        <img src="/img/svg/icon_dismiss.svg" alt="dismiss" />
                      </a>
                    )}
                    <td>
                      {!notification.read ? (
                        <SvgIcon
                          src={
                            isSelected
                              ? "/img/new-icons/checked-square.svg"
                              : "/img/new-icons/unchecked-square.svg"
                          }
                          onClick={(e) =>
                            handleSelectNotification(e, notification._id)
                          }
                        />
                      ) : (
                        <img
                          src="/img/new-icons/read-notification.svg"
                          height={24}
                          width={24}
                        />
                      )}
                    </td>
                    <td className="date">
                      {momentTZ(notification.date).calendar()}
                    </td>

                    <td className="title">
                      {notification.read ? (
                        <span>{notificationText}</span>
                      ) : (
                        <b>{notificationText}</b>
                      )}
                    </td>

                    {notification.button && (
                      <td className="actions">
                        <a
                          role="button"
                          data-button-type="outline"
                          href={notification.button.link.replace(
                            "http://app.mystrengthbook.com",
                            ""
                          )}
                        >
                          <span>{notification.button.text}</span>
                        </a>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </section>
      </section>
    </main>
  );
}

const Notifications = (app) => {
  app.get(
    "/notifications",
    set("heading", ["Notifications"]),
    ({ res, api, locals }) => (res.body = <View />)
  );
};

export default Notifications;
